import { render, staticRenderFns } from "./thirdRobot.vue?vue&type=template&id=0fa90307&scoped=true&"
import script from "./thirdRobot.vue?vue&type=script&lang=ts&"
export * from "./thirdRobot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa90307",
  null
  
)

export default component.exports